import { CONSUMER_CONTEXT_MENU_SERVICE_NAME, ConsumerContextMenuServiceProvider } from './consumer.context-menu.service'

export const CONSUMER_SERVICES_MODULE_NAME = 'simax.services.consumer'

const module = angular.module(CONSUMER_SERVICES_MODULE_NAME, [])

module.provider(CONSUMER_CONTEXT_MENU_SERVICE_NAME, ConsumerContextMenuServiceProvider)
